import { CoreMenuItem } from './menu-item.model';

export class AppMenu {
  items: CoreMenuItem[];
  otherItems?: CoreMenuItem[];

  constructor(init?: Partial<AppMenu>) {
    Object.assign(this, init);
  }
}
